import { Avatar } from '../../avatar';
import { Button } from '../../button';
import { Col } from '../../col';
import { Icon } from '../../icon';
import { Row } from '../../row';
import { Tag, type TagProperties } from '../../tag';
import { Text } from '../../typography';

const COLUMN_WIDTH = '48px';

export type HierarchyItem = {
  alt: string;
  avatarUrl?: string;
  fallbackPhoto?: string;
  id: string;
  name: string;
  path?: string;
  showArrow?: boolean;
  tag?: TagProperties;
};

type P = HierarchyItem;

const HierarchyTreeItem = ({ alt, avatarUrl, fallbackPhoto, name, path, showArrow, tag }: P) => (
  <div className="ui-hierarchy-tree-item">
    <Row
      align="middle"
      className="ui-hierarchy-tree-item__row ui-hierarchy-tree-item__row--with-padding"
      gutter={['ms', 0]}
      justify="space-between"
      wrap={false}
    >
      <Col className="ui-hierarchy-tree-item__col ui-hierarchy-tree-item__col--centered" flex={COLUMN_WIDTH}>
        <Avatar alt={alt} fallbackPhoto={fallbackPhoto} src={avatarUrl} />
      </Col>
      <Col className="ui-hierarchy-tree-item__col" flex="1">
        <Row>
          <Col span={24}>
            <Text ellipsis type="title" weight="medium">
              {name}
            </Text>
          </Col>

          {tag ? (
            <Col span={24}>
              <Tag {...tag} />
            </Col>
          ) : null}
        </Row>
      </Col>

      {path ? (
        <Col className="ui-hierarchy-tree-item__col">
          <Button navigate={{ to: path }} type="link-primary">
            View
          </Button>
        </Col>
      ) : null}
    </Row>

    {showArrow ? (
      <Row className="ui-hierarchy-tree-item__row" gutter={['ms', 0]}>
        <Col className="ui-hierarchy-tree-item__col ui-hierarchy-tree-item__col--centered" flex={COLUMN_WIDTH}>
          <Text className="ui-hierarchy-tree-item__divider" type="secondary">
            <Icon icon="down-line" size="middle" />
          </Text>
        </Col>
      </Row>
    ) : null}
  </div>
);

export default HierarchyTreeItem;
